const formatAmountNumber = (val, undefinedValue, fixed) => {
    if (val === null || val === undefinedValue) {
        return undefinedValue;
    }

    return Number.parseFloat(val).toFixed(2).replace(/[.]/, ",");
}

export default formatAmountNumber;